var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-screen-support"},[_c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('Header'),_c('div',{staticStyle:{"height":"120px"}}),_c('div',{staticClass:"main-layout"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('LoginDialog',{attrs:{"value":_vm.loginDialog}}),_c('Footer')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }